import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    alert('TEST controller works!')
    console.log('TEST controller connected')
  }
}